<template>
    <div>
        <div class="row">
            <div class="col-lg-12 mb-3">
                <b-card :header="$t('table.blinds')" header-tag="h3" class="bg-default-card">
                    <div class="row mb-3" v-if="this.$store.getters.hasPermission(['project_blind'], ['read'])">
                        <div class="ml-3" style="min-width: 260px;">
                            <p class="mb-1 text-nowrap">{{$t('table.filter_by_pressure_test')}}</p>
                            <multiselect v-model="selectedPressureTestFilter"
                                :options="currentPressureTestFilter"
                                :multiple="false"
                                :clear-on-select="true"
                                :hide-selected="false"
                                :loading="isPressureTestLoadingFilter"
                                :preserve-search="true"
                                placeholder=""
                                label="test_circuit_no" track-by="id"
                                :selectLabel="''"
                                @search-change="onPressureTestFilter"
                                @input="onFilterByPressureTest"
                            >
                                <template slot="clear" slot-scope="props">
                                    <div 
                                        v-if="selectedPressureTestFilter != null" 
                                        class="multiselect__clear" 
                                        @mousedown.prevent.stop="clearSelectedPressureTestFilter"
                                    >
                                    </div>
                                </template>
                                <span slot="noOptions">{{ $t('modal.general.list_is_empty') }}</span>
                                <span slot="noResult">{{ $t('modal.general.no_results') }}</span>
                            </multiselect>
                        </div>
                    </div>

                    <data-table
                        v-if="tableLoaded"
                        :exportable="true" title=""
                        :rows="getData.rowData"
                        :columns="columnData"
                        :perPage="perPage"
                        :rowsCount="rowsCount"
                        :currentPage="currentPage"
                        :pageCount="pageCount"
                        @exportButtonClick="onExportButton"
                        @changePage="changePage"
                        @searchEvent="searchEvent"
                        @orderByEvent="orderByEvent"
                    >
                    </data-table>
                </b-card>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import http from '@/libs/http';
import DataTable from '@/components/global/tables/datatables/DataTable.vue';
import miniToastr from 'mini-toastr';
import Multiselect from 'vue-multiselect';

export default {
    name: 'blinds_table',
    components: {
        DataTable,
        Multiselect,
    },
    props: {
        measureUnits: {
            type: Object,
            default: function () {
                return null;
            },
        },
    },
    data() {
        return {
            tableNameTranslated: Vue.i18n.translate('table.blinds'),
            tableName: 'blind',
            row: null,
            tableLoaded: false,
            perPage: 0,
            rowsCount: 0,
            pageCount: 1,
            currentPage: 1,
            sortType: 'asc',
            sortBy: 'id',
            searchInput: '',

            filters: {
                pressure_test_id: '',
            },

            selectedPressureTestFilter: null,
            currentPressureTestFilter: [],
            isPressureTestLoadingFilter: false,

            getData: {
                rowData: [],
            },
            columnData: [
                {
                    label: Vue.i18n.translate('table.test_circuit_no'),
                    field: 'pressure_test.test_circuit_no',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.description'),
                    field: 'project_setting_description.info',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.size'),
                    field: 'size',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.rating'),
                    field: 'rating',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.quantity'),
                    field: 'qty',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.unit'),
                    field: 'unitV',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.installed'),
                    field: 'installed',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.removed'),
                    field: 'removed',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.all_installed'),
                    field: 'all_installed',
                    numeric: false,
                    html: false,
                    showAsCheck: true,
                    cursor: false,
                },
                {
                    label: Vue.i18n.translate('table.all_removed'),
                    field: 'all_removed',
                    numeric: false,
                    html: false,
                    showAsCheck: true,
                    cursor: false,
                }
            ],
        }
    },
    mounted() {
        this.onLoadTable();
    },
    methods: {
        errorMsg(msg) {
            miniToastr.error(msg, Vue.i18n.translate('messages.error'), 5000);
        },
        successMsg(msg) {
            miniToastr.success(msg, Vue.i18n.translate('messages.success'), 5000);
        },
        infoMsg(msg) {
            miniToastr.info(msg, Vue.i18n.translate('messages.info'), 4000);
        },
        orderByEvent (column, sort_type) {
            this.sortType = sort_type;
            this.sortBy = column.field;
            this.onLoadTable();
        },
        searchEvent (searchInput) {
            this.searchInput = searchInput;
            this.onLoadTable();
        },
        changePage (page) {
            this.currentPage = page;
            this.onLoadTable();
        },
        onLoadTable () {
            http.route(this.tableName + '?project_id=' + this.$route.params.id + '&search=' + this.searchInput + '&page=' + this.currentPage + '&sort_by=' + this.sortBy + '&sort_order=' + this.sortType + '&filters[pressure_test_id]=' + this.filters.pressure_test_id + '&filters[parent_pressure_test_id]=null').get()
            .then(response => {
                if (!response.isError) {
                    this.perPage     = response.pagination.limit;
                    this.rowsCount   = response.pagination.totalEntries;
                    this.currentPage = response.pagination.currentPage;
                    this.pageCount   = response.pagination.totalPages;

                    response.data.forEach(field => {
                        if (typeof this.measureUnits[field.unit].name != 'undefined') {
                            field.unitV = this.measureUnits[field.unit].name;
                        }
                    });
                    this.getData.rowData = response.data;
                    this.tableLoaded = true;
                } else {
                    Object.keys(response.errorMessage).forEach(key => {
                        this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                    });
                }
            });
        },
        onExportButton() {
            http.route(this.tableName).exportExcel({
                export: 1,
                project_id: this.$route.params.id,
                search: this.searchInput,
                sort_by: this.sortBy,
                sort_order: this.sortType
            }, 'blinds.xlsx').then(response => {
                if (typeof response != 'undefined') {
                    this.errorMsg(Vue.i18n.translate('errors.error_export'));
                } else {
                    this.successMsg(this.tableNameTranslated + Vue.i18n.translate('messages.exported'));
                }
            });
        },
        onPressureTestFilter(search) {
            if (search == '') {
                this.currentPressureTestFilter = [];
                
                return false;
            }

            this.isPressureTestLoadingFilter = true;
            this.filterPressureTest(search, this);
        },
        filterPressureTest: _.debounce((search, vm) => {
            let data = http.route('pressuretest?project_id='+ vm.$route.params.id +'&get_all=1&search_select=' + search + '&filters[parent_pressure_test_id]=null').get();
            data.then(response => {
                if (response.data != false) {
                    vm.currentPressureTestFilter = response.data;
                }
                vm.isPressureTestLoadingFilter = false;
            });
        }, 500),
        onFilterByPressureTest (pressure_test) {
            this.filters.pressure_test_id = (pressure_test != null) ? pressure_test.id : '';

            this.onLoadTable();
            this.infoMsg(Vue.i18n.translate('messages.table_filtered'));
        },
        clearSelectedPressureTestFilter () {
            this.selectedPressureTestFilter = null;
            this.filters.pressure_test_id = '';
            this.onLoadTable();
        },
    }
}
</script>

<style scoped>
	select {
		-webkit-appearance:menulist-button;
		-moz-appearance:menulist-button;
	}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>


// WEBPACK FOOTER //
// src/components/pages/project/blinds_and_removed_items/blinds_table.vue